export default __webpack_public_path__ + "static/media/rekava-icon-navy.26333639.svg";